/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePartnerDto
 */
export interface UpdatePartnerDto {
    /**
     * 
     * @type {string}
     * @memberof UpdatePartnerDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePartnerDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePartnerDto
     */
    mobile?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePartnerDto
     */
    _function?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePartnerDto
     */
    isSigner?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePartnerDto
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePartnerDto
     */
    comment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePartnerDto
     */
    title?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdatePartnerDto
     */
    type?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePartnerDto
     */
    isCompany?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePartnerDto
     */
    parentId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePartnerDto
     */
    active?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePartnerDto
     */
    companyWorkforce?: number | null;
}

/**
 * Check if a given object implements the UpdatePartnerDto interface.
 */
export function instanceOfUpdatePartnerDto(value: object): value is UpdatePartnerDto {
    return true;
}

export function UpdatePartnerDtoFromJSON(json: any): UpdatePartnerDto {
    return UpdatePartnerDtoFromJSONTyped(json, false);
}

export function UpdatePartnerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePartnerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'mobile': json['mobile'] == null ? undefined : json['mobile'],
        '_function': json['function'] == null ? undefined : json['function'],
        'isSigner': json['is_signer'] == null ? undefined : json['is_signer'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'title': json['title'] == null ? undefined : json['title'],
        'type': json['type'] == null ? undefined : json['type'],
        'isCompany': json['is_company'] == null ? undefined : json['is_company'],
        'parentId': json['parent_id'] == null ? undefined : json['parent_id'],
        'active': json['active'] == null ? undefined : json['active'],
        'companyWorkforce': json['company_workforce'] == null ? undefined : json['company_workforce'],
    };
}

export function UpdatePartnerDtoToJSON(json: any): UpdatePartnerDto {
    return UpdatePartnerDtoToJSONTyped(json, false);
}

export function UpdatePartnerDtoToJSONTyped(value?: UpdatePartnerDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'email': value['email'],
        'mobile': value['mobile'],
        'function': value['_function'],
        'is_signer': value['isSigner'],
        'phone': value['phone'],
        'comment': value['comment'],
        'title': value['title'],
        'type': value['type'],
        'is_company': value['isCompany'],
        'parent_id': value['parentId'],
        'active': value['active'],
        'company_workforce': value['companyWorkforce'],
    };
}

